import { Immutable } from 'nuclear-js';

export const deepCompare = (object1, object2, logToConsole = false, component = '') => {
    // some of our props contain immutable objects that have the same contents but appear to be different when
    //      equality is evaluated shallowly.  This can lead to unnecessary rendering because it looks like props
    //      or state has changed, when it really hasn't.
    // This function will perform a deep compare on Immutable objects but a shallow compare on everything else
    if (!object1 && !object2) {
        return true;
    } else if ((!object1 && object2) || (object1 && !object2)) {
        return false;
    } else if (object1 === object2) {
        return true;
    } else if (Object.keys(object1).length !== Object.keys(object2).length) {
        return false;
    }

    return Object.keys(object1).reduce((acc, nextKey) => {
        let matchYn = false;
        if (!acc) {
            return false;
        } else if (!object2.hasOwnProperty(nextKey)) {
            return false;
        } else if (object1[nextKey] === object2[nextKey]) {
            // try the shallow compare first
            return true;
        } else if (Immutable.Iterable.isIterable(object1[nextKey])) {
            matchYn =
                Immutable.Iterable.isIterable(object2[nextKey]) && Immutable.is(object1[nextKey], object2[nextKey]);
        } else {
            matchYn = object1[nextKey] == object2[nextKey];
        }
        if (logToConsole && !matchYn) {
            console.log(`${nextKey} did not match for ${component}`);
        }
        return matchYn;
    }, true);
};

export const DeepCompareComponentShouldUpdateMixin = {
    shouldComponentUpdate: function(nextProps, nextState) {
        return !deepCompare(nextProps, this.props) || !deepCompare(nextState, this.state);
    },
};

export default {
    deepCompare,
    DeepCompareComponentShouldUpdateMixin,
};
